import '@babel/polyfill';
import './hotfix';
import { TBinaryXmlHttpTransport, BinaryProtocol } from 'evernote-thrift';
import getTransportOpts from 'ion-utils/lib/getTransportOpts';
import { configure } from 'ion-registry';
import Broker, { logRecentBroker } from 'ion-broker/impl';
import { triggerLogin, triggerLogout } from 'evernote-auth/redirect';
import localForage from 'localforage';
import { removeDesktopOnlyNoteActionItems } from '../../components/NoteActionsDropdown/dropdownItemFilters';
import { enable as enableLog } from 'pretend_modules/ion-logger';

const logLevel = (localStorage.getItem('ion-loglevel') || '').toUpperCase();
if (logLevel === 'INFO' || logLevel === 'DEBUG') {
  enableLog('*');
}

declare global {
  interface Window {
    Cupboard: object;
    logRecentBroker: () => void;
    logDataSources: () => void;
    logCompressedDataSources: () => void;

    Intercom(
      trackEvent: string,
      createdSpace: string,
      param3?: { space_count: number }
    ): void;
  }
}

localForage.config({
  name: 'evernote',
  storeName: 'sugar'
});

// Configure the global object registry before doing anything else
// 这个在各个端都有一个配置, 用来配置不同端达到相同目的使用的工具
configure({
  applicationTitle: '印象笔记',
  applicationRole: 'web',
  isAutoUpdateAllowed: false,
  broker: Broker,
  localizedAppTitleKey: 'Account.header.title',
  objectPersistence: localForage,
  noteActionDropdownFilter: removeDesktopOnlyNoteActionItems,
  thriftTransport(url: string) {
    return new TBinaryXmlHttpTransport(url, getTransportOpts());
  },
  thriftProtocol(transport: TBinaryXmlHttpTransport) {
    return new BinaryProtocol(transport);
  },
  triggerLogin,
  triggerLogout
});

// require these modules late because they have side effects which depend on a configured registry
(async () => {
  const { logDataSources, logCompressedDataSources } = await import('evernote-sugar');
  await import('ion-actions');
  await import('./client');

  // Attach debugging utils to the window
  window.Cupboard = (await import('evernote-cupboard')).default;
  window.logRecentBroker = logRecentBroker;
  window.logDataSources = logDataSources;
  window.logCompressedDataSources = logCompressedDataSources;
})();
